<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'learning_paths.add_' + type | translate}}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content class="">
        <mat-selection-list class="content-list" [(ngModel)]="selectedItems">
          @for (item of content; track item.id) {
            <mat-list-option [value]="item">
              <div class="item">
                <div class="image" [style.background-image]="'url(' + getImage(item.picture) + ')' "></div>
                <div class="item-title">{{item.title}}</div>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>

      <div class="button-wrapper">
        <button mat-raised-button (click)="saveContent()">
          {{'main.save' | translate}}
        </button>
      </div>
</div>
